import { render, staticRenderFns } from "./VideoContent.vue?vue&type=template&id=20c78c9e&"
import script from "./VideoContent.vue?vue&type=script&lang=js&"
export * from "./VideoContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports